var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"temp-space"},[_c('div',{staticClass:"signature-box"},[_c('VueSignaturePad',{ref:"signaturePad",attrs:{"width":"100%","height":"200px","options":_vm.signOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }